if (!Array.prototype.last) {
  Array.prototype.last = (function () {
    return function () {
      return this[this.length - 1]
    }
  })()
}

Element.prototype.documentOffsetTop = function () {
  return (
    this.offsetTop +
    (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
  )
}
